import { TextInput } from '@mantine/core';
import classes from '../input.module.css';
import { defaultInputProps } from '../default-props';
export const textInputProps = TextInput.extend({
    classNames: classes,
    defaultProps: defaultInputProps,
});
